import AIServiceCard from './AIServiceCard';

export default AIServiceCard;
